import React, {memo} from 'react';
import cx from 'classnames';

const List = memo( ( {children, className, ...props} ) =>
    <div {...props} className={cx( 'ut-search-suggestions-list no-bullet', className )}>{children}</div>
);

export default List;
